const dateth = (date) => {
  const dateNew = new Date(date);
  const result = dateNew.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return result;
};

const formatDate = (date) => {
  const dateNew = new Date(date);

  const result = dateNew.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return (
    result +
    " " +
    dateNew.getHours() +
    ":" +
    dateNew.getMinutes() +
    ":" +
    dateNew.getSeconds()
  );
};

const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === "http:" || url.protocol === "https:";
};

const pad = (num) => {
  var str = String(num);
  while (str.length < 4) str = "0" + str;
  return str;
};

export { dateth, formatDate, isValidHttpUrl, pad };
